import Model from "../model";
import Promotion from "../promotion/model";
import { NormalizedModel } from "../utils/normalized/types";

export const ModelType = "SUBSCRIPTION";

export default class Subscription extends Model {
  // Attributes
  upcomingInvoiceAt: string = "";
  ritualName: string = "";
  // Relationships
  userId: string = "";
  addressId: string = "";
  paymentSourceId: string = "";
  promotions: Array<Promotion> = [];

  constructor(attributes: { [key: string]: any }) {
    super();
    this.addAttributes(attributes);
  }

  deserialize(input: NormalizedModel) {
    this.id = input.id;
    this.addAttributes(input.attributes);

    const relationships = input.relationships;
    this.userId = this.getRelationshipId(relationships, "user");
    this.addressId = this.getRelationshipId(relationships, "address");
    this.paymentSourceId = this.getRelationshipId(
      relationships,
      "payment_source",
    );
  }
}
